<template>
    <div class="KM-table">
        <!-- :data="k_table.slice((k_pageInfo.pageNum-1)*k_pageInfo.pageSize,k_pageInfo.pageNum*k_pageInfo.pageSize)" -->
        <el-table
            v-if="cluster_table&&cluster_table.length!=0"
            :header-cell-style="{background:'#a7754f',color:'#fff'}"
            size='mini'
            :data="cluster_tableList"
            row-key="id"
            border
            default-expand-all
            style="width: 100%">
            <el-table-column
                label="clusterId"
                sortable
                align="center"
                prop="num"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="name"
                sortable
                label="名称">
            </el-table-column>
        </el-table>
        <el-pagination 
            size='small'
            class="page-wrap"  
            @current-change="changePage" 
            @size-change="sizeChange"
            background
            :current-page="cluster_pageInfo.pageNum" 
            :page-count="cluster_pageInfo.pageTotal" 
            :page-size="cluster_pageInfo.pageSize"
            :page-sizes="[10, 20, 30, 50, 100]"
            :total="cluster_pageInfo.total"
            layout="total, sizes, prev, pager, next, jumper" >
        </el-pagination>
    </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'
export default {
    data () {
        return {
            // pageInfo: {
            //     pageNum: 1,
            //     pageTotal: 1,
            //     total: 1,
            //     pageSize: 10,
            // },
        }
    },
    computed: {
        ...mapState({
            cluster_table:state=>state.excavate.cluster_table,
            cluster_tableList:state=>state.excavate.cluster_tableList,
            cluster_pageInfo:state=>state.excavate.cluster_pageInfo,
        })
        
    },
    mounted() {
       
    },
    methods: {
        changePage(num) {
            this.$store.state.excavate.cluster_pageInfo.pageNum=num;
            this.$store.state.excavate.cluster_tableList= this.cluster_table.slice((this.cluster_pageInfo.pageNum-1)*this.cluster_pageInfo.pageSize,this.cluster_pageInfo.pageNum*this.cluster_pageInfo.pageSize);
            // }
        },
        sort_change(column) { // column是个形参，具体查看element-ui文档
            this.column = column;
            // sizeChange
            this.$store.state.excavate.total = this.cluster_table.length
            this.$store.state.excavate.cluster_table = this.cluster_table.sort(this.sortFun(column.prop, column.order === 'ascending'));
            // 回到第一页
            this.changePage(1);

        },
        sortFun (attr, rev) {
            //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
            if (rev == undefined) {
                rev = 1;
            } else {
                rev = (rev) ? 1 : -1;
            }
            return function (a, b) {
                a = a[attr];
                b = b[attr];
                if (a < b) {
                    return rev * -1;
                }
                if (a > b) {
                    return rev * 1;
                }
                return 0;
            }
        },
        // 每页条数
        sizeChange(val) {
            this.$store.state.excavate.cluster_pageInfo={
                pageSize:val,
                total:this.cluster_pageInfo.total,
                pageTotal:Math.ceil(this.cluster_pageInfo.total/val),
                pageNum:this.cluster_pageInfo.pageNum,
            }
            this.changePage(1)
            this.$store.state.excavate.cluster_pageInfo.pageSize=val;
        },

    }
}
</script>

<style>

</style>